import { BRAND_LIST, COUNTRY, LANGUAGE } from "@type/index";

export const contactUsUrl: { [key: string]: string } = {
  [`${BRAND_LIST.UQ}${COUNTRY.AT}`]: "https://faq-eu.uniqlo.com/",
  [`${BRAND_LIST.UQ}${COUNTRY.BE}`]: "https://faq-be.uniqlo.com/",
  [`${BRAND_LIST.UQ}${COUNTRY.BE}${LANGUAGE.FR}`]:
    "https://faq-be.uniqlo.com/pkb_Home_UQ_BE?l=fr",
  [`${BRAND_LIST.UQ}${COUNTRY.BE}${LANGUAGE.NL}`]:
    "https://faq-be.uniqlo.com/pkb_Home_UQ_BE?l=nl_NL",
  [`${BRAND_LIST.UQ}${COUNTRY.BE}${LANGUAGE.EN}`]: "https://faq-be.uniqlo.com/",
  [`${BRAND_LIST.UQ}${COUNTRY.BG}`]: "https://faq-eu.uniqlo.com/",
  [`${BRAND_LIST.UQ}${COUNTRY.CZ}`]: "https://faq-eu.uniqlo.com/",
  [`${BRAND_LIST.UQ}${COUNTRY.DE}`]: "https://faq-de.uniqlo.com/",
  [`${BRAND_LIST.UQ}${COUNTRY.DE}${LANGUAGE.EN}`]:
    "https://faq-de.uniqlo.com/pkb_Home_UQ_DE?l=en_US",
  [`${BRAND_LIST.UQ}${COUNTRY.DK}`]: "https://faq-dk.uniqlo.com/",
  [`${BRAND_LIST.UQ}${COUNTRY.EE}`]: "https://faq-eu.uniqlo.com/",
  [`${BRAND_LIST.UQ}${COUNTRY.ES}`]: "https://faq-es.uniqlo.com/",
  [`${BRAND_LIST.UQ}${COUNTRY.ES}${LANGUAGE.EN}`]:
    "https://faq-es.uniqlo.com/pkb_Home_UQ_ES?l=en_US",
  [`${BRAND_LIST.UQ}${COUNTRY.FI}`]: "https://faq-eu.uniqlo.com/",
  [`${BRAND_LIST.UQ}${COUNTRY.FR}`]: "https://faq-fr.uniqlo.com/",
  [`${BRAND_LIST.UQ}${COUNTRY.FR}${LANGUAGE.EN}`]:
    "https://faq-fr.uniqlo.com/pkb_Home_UQ_FR?l=en_US",
  [`${BRAND_LIST.UQ}${COUNTRY.GR}`]: "https://faq-eu.uniqlo.com/",
  [`${BRAND_LIST.UQ}${COUNTRY.HR}`]: "https://faq-eu.uniqlo.com/",
  [`${BRAND_LIST.UQ}${COUNTRY.HU}`]: "https://faq-eu.uniqlo.com/",
  [`${BRAND_LIST.UQ}${COUNTRY.IE}`]: "https://faq-eu.uniqlo.com/",
  [`${BRAND_LIST.UQ}${COUNTRY.IT}`]: "https://faq-it.uniqlo.com/",
  [`${BRAND_LIST.UQ}${COUNTRY.IT}${LANGUAGE.EN}`]:
    "https://faq-it.uniqlo.com/pkb_Home_UQ_IT?l=en_US",
  [`${BRAND_LIST.UQ}${COUNTRY.JP}`]: "https://faq.uniqlo.com/",
  [`${BRAND_LIST.UQ}${COUNTRY.KR}`]: "https://faq-kr.uniqlo.com/",
  [`${BRAND_LIST.UQ}${COUNTRY.LT}`]: "https://faq-eu.uniqlo.com/",
  [`${BRAND_LIST.UQ}${COUNTRY.LU}`]: "https://faq-eu.uniqlo.com/",
  [`${BRAND_LIST.UQ}${COUNTRY.LV}`]: "https://faq-eu.uniqlo.com/",
  [`${BRAND_LIST.UQ}${COUNTRY.NL}`]: "https://faq-NL.uniqlo.com/",
  [`${BRAND_LIST.UQ}${COUNTRY.NL}${LANGUAGE.NL}`]:
    "https://faq-nl.uniqlo.com/pkb_Home_UQ_NL?l=nl_NL",
  [`${BRAND_LIST.UQ}${COUNTRY.NL}${LANGUAGE.EN}`]: "https://faq-NL.uniqlo.com/",
  [`${BRAND_LIST.UQ}${COUNTRY.PL}`]: "https://faq-eu.uniqlo.com/",
  [`${BRAND_LIST.UQ}${COUNTRY.PT}`]: "https://faq-eu.uniqlo.com/",
  [`${BRAND_LIST.UQ}${COUNTRY.RO}`]: "https://faq-eu.uniqlo.com/",
  [`${BRAND_LIST.UQ}${COUNTRY.SE}`]: "https://faq-se.uniqlo.com/",
  [`${BRAND_LIST.UQ}${COUNTRY.SI}`]: "https://faq-eu.uniqlo.com/",
  [`${BRAND_LIST.UQ}${COUNTRY.SK}`]: "https://faq-eu.uniqlo.com/",
  [`${BRAND_LIST.UQ}${COUNTRY.UK}`]: "https://faq-uk.uniqlo.com/",
  [`${BRAND_LIST.UQ}${COUNTRY.US}`]: "https://faq-us.uniqlo.com/",
  [`${BRAND_LIST.GU}${COUNTRY.JP}`]: "https://faq.gu-global.com/",
  [`${BRAND_LIST.GU}${COUNTRY.US}`]: "https://faq-us.gu-global.com/",
  [`${BRAND_LIST.PL}${COUNTRY.BG}`]: "https://faq.plst.com/"
};
